import UmamiContext from "@/contexts/UmamiContext";
import { useSetupUmami } from "@/hooks/useSetupUmami";
import { Outlet } from "react-router-dom";

export default function UmamiWrapper() {
	const umamiData = useSetupUmami();

	return (
		<UmamiContext.Provider value={umamiData}>
			<Outlet />
		</UmamiContext.Provider>
	);
}
